import ReactPlayer from 'react-player';
import styled from 'styled-components';

const InvisibleMusicPlayer = styled(ReactPlayer)`
  display: none;
`;
export default InvisibleMusicPlayer;
